// extracted by mini-css-extract-plugin
export default {"logo":"NavBar_logo__4hZwQ","nav-link":"NavBar_nav-link__GXayb"};